import { env } from "./env";
import { assertValue } from "./utils";

export const dataset = env.NEXT_PUBLIC_SANITY_DATASET ?? "production";

export const projectId = assertValue(
  env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  "Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID",
);

/**
 * see https://www.sanity.io/docs/api-versioning for how versioning works
 */
export const apiVersion =
  /**sanity studio api version */
  env.NEXT_PUBLIC_SANITY_API_VERSION || "2025-02-10";

/**
 * Used to configure edit intent links, for Presentation Mode, as well as to configure where the Studio is mounted in the router.
 */
export const studioUrl =
  env.NEXT_PUBLIC_SANITY_STUDIO_URL || "http://localhost:3333";
